import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-accent-500"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                亚洲精品视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚亚洲各地高品质影视内容，涵盖电影、电视剧、纪录片、短片等多元类型，为用户提供流畅高清的正版视频体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/dianying" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                contact@asianpremiumvideo.com
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                400-888-0000
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                北京市朝阳区建国路88号
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 亚洲精品视频 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}